module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/GooglePlayText-3ec2e035f00f9158f6f674037b1758d1.svg";